<template>
  <div>
    <section>
      <b-container fluid class="d-flex justify-content-center banner-faq">
        <b-row align-v="center">
          <b-col>
            <h1 class="banner-text">Supprimer mon compte</h1>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="sec-back">
      <div style="display: flex; flex-direction: column;">
        <div class="form-group">
          <label class="form-label" for="email">Adresse email</label>
          <input
            type="email"
            class="form-input"
            id="email"
            aria-describedby="emailHelp"
            placeholder="Entrez votre adresse email"
          />
          <small id="emailHelp" class="form-text text-muted"
            >Nous ne partagerons jamais votre adresse email avec quelqu'un d'autre.</small
          >
        </div>
        <div class="form-group">
          <label class="form-label" for="reason">Raison</label>
          <select class="form-input" id="reason">
            <option>Je reçois trop d'emails</option>
            <option>Je ne suis plus intéressé(e)</option>
            <option>Autre</option>
          </select>
        </div>
        <button type="submit" class="btn btn-primary">Supprimer mon compte</button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  
};
</script>

<style scoped>
.banner-faq {
  background-clip: border-box;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/healthy-scaled.jpg");
  /*linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)), top 150px center fixed no-repeat; */
  margin: 50px 0;

  width: 100%;
  height: 700px;
  background-attachment: fixed;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.banner-text {
  font-family: "Amanise";
  font-size: clamp(36px, 4vw + 29px, 84px);
  font-weight: 400;
  color: white;
}

.faq-container {
  background-color: #edf4d9;
  padding: 20px;
  border-radius: 15px;
}

.sec-back {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
}

</style>
